import { c as _c } from "react/compiler-runtime";
import type { LinearIssue } from '@/lib/linear/types';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useDebounceValue } from 'usehooks-ts';
export function useIssueSearch(installationId) {
  const $ = _c(16);
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounceValue(search, 300);
  let t0;
  let t1;
  if ($[0] !== debouncedSearch || $[1] !== installationId) {
    t0 = ["linear-search", debouncedSearch, installationId];
    t1 = async () => {
      const res = await fetch(`/api/linear/issue/search?term=${encodeURIComponent(debouncedSearch)}&installationId=${installationId}`);
      if (!res.ok) {
        throw new Error("Failed to search issues");
      }
      return res.json();
    };
    $[0] = debouncedSearch;
    $[1] = installationId;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  const t2 = debouncedSearch.length > 0 && !!installationId;
  let t3;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      staleTime: 10000,
      gcTime: 10000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    data,
    isLoading,
    error
  } = useQuery(t3);
  let t4;
  if ($[8] !== data?.issues) {
    t4 = data?.issues || [];
    $[8] = data?.issues;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = error?.message || "";
  let t6;
  if ($[10] !== debouncedSearch || $[11] !== isLoading || $[12] !== search || $[13] !== t4 || $[14] !== t5) {
    t6 = {
      search,
      setSearch,
      debouncedSearch,
      searchResults: t4,
      isLoading,
      error: t5
    };
    $[10] = debouncedSearch;
    $[11] = isLoading;
    $[12] = search;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}